var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.832 20C13.2907 18.8987 12.6093 17.6853 11.788 16.36C10.9667 15.0347 10.108 13.756 9.212 12.524C8.83867 13.0093 8.428 13.588 7.98 14.26C7.55067 14.932 7.112 15.6227 6.664 16.332C6.23467 17.0227 5.83333 17.6947 5.46 18.348C5.08667 19.0013 4.788 19.552 4.564 20H0.56C1.4 18.4133 2.37067 16.7893 3.472 15.128C4.57333 13.448 5.768 11.6933 7.056 9.864L0.84 0.595999H5.04L9.324 7.232L13.552 0.595999H17.584L11.452 9.836C12.8707 11.7587 14.1213 13.5787 15.204 15.296C16.3053 17.0133 17.2293 18.5813 17.976 20H13.832Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.13f4fca58552551ef9a229f6106af0f2.svg";
export { ForwardRef as ReactComponent };